import Layout from '@/components/feature/Layout';
import ServiceDetailLayout from '@/pages/services/components/ServiceDetailLayout';
import { serviceDetails } from '@/mocks/service-details';

export default function FlooringWallPanelingPage() {
  return (
    <Layout>
      <ServiceDetailLayout data={serviceDetails['flooring-wall-paneling']} />
    </Layout>
  );
}